import { render, staticRenderFns } from "./approveorganizationusers.vue?vue&type=template&id=fe97a698"
import script from "./approveorganizationusers.vue?vue&type=script&lang=js"
export * from "./approveorganizationusers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports